import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled"
import {ReactComponent as ButtonBackground} from "../../assets/HexagonOutline.svg";


const ButtonWrapper = styled.div`
  /* default/shade/white */
    width: 40px;
    height: 40px;
    
    display: flex;
    justify-content: center;
    
    align-items: center;
    user-select: none;
    
    &:hover{
      background-color: var(--gray-secondary);
    }
`;


export default function HexagonButton(props) {
    // eslint-disable-next-line no-unused-vars
    let {alt, Icon, onClick} = props;

    return (
        <ButtonWrapper onClick={onClick}>
            <ButtonBackground/>
            {/*<Launch style={{position: "absolute"}}/>*/}
            <Icon style={{position: "absolute"}}/>

        </ButtonWrapper>
    )
}

HexagonButton.propTypes = {
    alt: PropTypes.string,
    onClick: PropTypes.func,
    Icon: PropTypes.any
};